import { FilePreviewWrapper } from './file-preview-wrapper';

export default FilePreviewWrapper;
